import React from "react";
import styled from "styled-components";
import { color, fontFamily, fontSize, spacingDefaults } from "style/constants";

interface StyledProps {
  bold?: boolean;
  color?: color;
  fontFamily?: fontFamily;
  fontSize?: fontSize;
  fontWeight?: string;
  lineHeight?: fontSize;
  margin?: string;
  textDecoration?: string;
}

const StyledP = styled.p<StyledProps>`
  color: ${props => (props.color ? props.color : color.DARKERGRAY)};
  margin: ${props => (props.margin ? props.margin : spacingDefaults.normal + " 0;")};
  font-family: ${props => (props.fontFamily ? props.fontFamily : fontFamily.primary)};
  font-style: normal;
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 300)};
  font-size: ${props => (props.fontSize ? props.fontSize : fontSize.normal)};
  line-height: ${props => (props.lineHeight ? props.lineHeight : fontSize.large)};
  text-decoration: ${props => (props.textDecoration ? props.textDecoration : "none")};
`;

interface Props {
  bold?: boolean;
  color?: color;
  fontFamily?: fontFamily;
  fontSize?: fontSize;
  fontWeight?: string;
  lineHeight?: fontSize;
  margin?: string;
  textDecoration?: string;
  children: React.ReactText;
}

const Paragraph: React.FC<Props> = ({
  children,
  bold,
  color,
  fontFamily,
  fontSize,
  fontWeight,
  lineHeight,
  margin,
  textDecoration
}: Props) => {
  return (
    <StyledP
      bold={bold}
      color={color}
      fontFamily={fontFamily}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      margin={margin}
      textDecoration={textDecoration}
    >
      {children}
    </StyledP>
  );
};

export default Paragraph;
